// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-template-manage .table-title-btns[data-v-082088a9] {\n  width: 100%;\n  margin-bottom: 15px;\n  text-align: right;\n}\n.file-template-manage .upload-card[data-v-082088a9] {\n  width: 80px;\n  height: 80px;\n}", ""]);
// Exports
module.exports = exports;
